<template>
  <wHeader v-if="navList.length" :navList="navList" @on-language="onOnLanguage"></wHeader>

  <div class="h-[60px] md:h-[90px]"></div>


  <div>
    <router-view></router-view>
  </div>

  <wFooter :navList="navList" :footInfo="footInfo"></wFooter>

  <el-dialog 
    v-model="outerVisible" 
    :title="$t('选择语言')" 
    :width="dialogWidth" 
    :close-on-click-modal="true"
    class="language-dialog mobile-dialog">
    <div class="flex flex-col items-center justify-center mt-3 md:mt-5">
      <div class="h-[36px] md:h-[40px] w-full max-w-[200px] text-[14px] md:text-[16px] cursor-pointer hover:text-[#DF0913] flex items-center"
        :class="curIndex == index ? 'text-[#DF0913]' : ''" v-for="(item, index) in LANGUAGES" :key="index"
        @click="changeLanguage(item, index)">
        <img class="w-[18px] md:w-[20px] h-[18px] md:h-[20px] mr-6 md:mr-10 flex-shrink-0" :src="curIndex == index ? checked : check" alt="" />
        <span class="truncate">{{ item.name }}</span>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer flex flex-row gap-3 justify-center">
        <el-button :size="buttonSize" @click="outerVisible = false">{{ $t('取消') }}</el-button>
        <el-button type="danger" :size="buttonSize" @click="handleLanglage">{{ $t('确定') }}</el-button>
      </div>
    </template>
  </el-dialog>

</template>

<script setup>
import check from '@/assets/images/check.png'
import checked from '@/assets/images/checked.png' // 需要添加hover状态的图片
import { validate } from '@/utils/formValidate'
import { h, ref, reactive, computed, shallowRef, onMounted } from 'vue'
import wHeader from "@/components/w-Header";
import wFooter from "@/components/w-Footer";
import { useRoute, useRouter } from 'vue-router'
const route = useRoute();
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { get67136603afdea, get67137f2b11bdd } from '@/apis/api'
import { LANGUAGES, storage } from '@/apis/config'
import { useStore } from 'vuex'
const store = useStore();

//翻译弹窗
const outerVisible = ref(false)
const curIndex = ref(null)
const language = ref(null)
const local = computed(() => store.state.local);
const changeLanguage = (item, index) => {
  language.value = item.value
  curIndex.value = index
}

//确定语言
const handleLanglage = () => {
  outerVisible.value = false
  store.commit('setLocal', language.value);
  window.location.reload()
}

//回显语言
const onOnLanguage = () => {
  outerVisible.value = true
  if (storage.get('Language')) {
    let local = LANGUAGES.find(item => item.value == storage.get('Language'))
    curIndex.value = LANGUAGES.findIndex(item => item.value == storage.get('Language'))
  } else {
    let local = LANGUAGES[0]
    curIndex.value = 0
  }
}


//头部导航
const navList = ref([])
const getNavFuns = async () => {
  const { code, data } = await get67136603afdea()
  if (code == 1) {
    data.unshift({
      aid: 10,
      name: t('首页'),
      path: 'home'
    })
    // console.log(data)
    navList.value = data
  }
}

const footInfo = ref({})
const getFootInfoFuns = async () => {
  try {
    const { code, data } = await get67137f2b11bdd()
    if (code == 1) {
      footInfo.value = data
    }
  } catch (error) {
    console.error(t('请求接口失败:'), error)
  }
}

// 响应式对话框宽度
const dialogWidth = computed(() => {
  if (typeof window !== 'undefined') {
    const width = window.innerWidth
    if (width < 640) {
      return '85%'
    } else if (width < 768) {
      return '80%'
    } else if (width < 1024) {
      return '400px'
    }
    return '380px'
  }
  return '380px'
})

// 响应式按钮尺寸
const buttonSize = computed(() => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 768 ? 'small' : 'default'
  }
  return 'default'
})

onMounted(() => {
  getNavFuns()
  getFootInfoFuns()
})

</script>

<style lang="scss" scoped>
:deep(.t-none-icon.is-required:not(.is-no-asterisk).asterisk-left>.el-form-item__label:before) {
  color: #fff;
}

.w-btn {
  margin-top: 40px;
  margin-bottom: 30px;
  @apply w-full md:w-[300px] md:mx-auto h-[46px] bg-[#E44040] text-[16px] text-[#fff] flex items-center justify-center hover:opacity-90 border cursor-pointer
}

:deep(.el-icon.el-input__icon p) {
  color: #333;
  font-style: normal;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: #E44040;
  background: #E44040;
}

:deep(.el-radio__input.is-checked+.el-radio__label) {
  color: #E44040;
}

.my-textarea :deep(.el-textarea__inner) {
  height: 90px;
  background-color: #f8f8f8;
}

.my-form-item :deep(.el-form-item__content) {
  display: flex;
  justify-content: space-between;
}

// 语言选择对话框移动端优化
:deep(.language-dialog) {
  .el-dialog {
    margin: 5vh auto !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    
    @media (max-width: 767px) {
      margin: 10vh auto !important;
      max-width: 90vw;
    }
  }
  
  .el-dialog__body {
    padding: 15px 20px !important;
    overflow-y: auto;
    flex: 1;
    
    @media (max-width: 767px) {
      padding: 12px 16px !important;
      max-height: calc(90vh - 120px);
    }
  }
  
  .el-dialog__header {
    padding: 15px 20px !important;
    
    @media (max-width: 767px) {
      padding: 12px 16px !important;
    }
  }
  
  .el-dialog__title {
    font-size: 16px;
    
    @media (max-width: 767px) {
      font-size: 14px;
    }
  }
  
  .el-dialog__footer {
    padding: 10px 20px !important;
    
    @media (max-width: 767px) {
      padding: 10px 16px !important;
    }
  }
  
  .el-button {
    @media (max-width: 767px) {
      min-width: 70px;
      padding: 6px 12px;
      font-size: 13px;
    }
    
    @media (min-width: 768px) {
      min-width: 90px;
      padding: 8px 20px;
    }
  }
}
</style>
